// extracted by mini-css-extract-plugin
module.exports = {"SideBarSectionCardHead":"SideBarSection-module--SideBarSectionCardHead--2eook"};